import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import Seo from "../components/Seo/Seo";
import "./RequestForm.css";

const RequestForm = () => {
  // Ref for the form element and textarea
  const formRef = useRef(null);
  const textareaRef = useRef(null);
  // State to determine if the form has been submitted successfully
  const [submitted, setSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [isSending, setIsSending] = useState(false);

  // Function for automatic textarea resizing
  const autoResizeTextarea = () => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = "auto";
      textarea.style.height = `${textarea.scrollHeight}px`;
    }
  };

  // Form submission handler using EmailJS
  const handleSubmit = (e) => {
    e.preventDefault();
    setErrorMessage(null);
    setIsSending(true);

    emailjs
      .sendForm(
        "service_02f1b5n",
        "template_a1924op",
        formRef.current,
        { publicKey: "Et4UfxopuEn0IbQm8" }
      )
      .then(
        () => {
          setSubmitted(true);
        },
        (error) => {
          console.error("E-Mail-Versand fehlgeschlagen", error);
          setErrorMessage(
            "Beim Versenden Ihrer Anfrage ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut oder schreiben Sie uns direkt an info@nexite-it.com."
          );
        }
      )
      .finally(() => {
        setIsSending(false);
      });
  };

  // If submitted, render the success message in a full-height section
  if (submitted) {
    return (
      <section className="success-section">
        <div className="success-container">
          <div className="success-header">
            <h1>Vielen Dank!</h1>
          </div>
          <p>
            Ihre E-Mail wurde erfolgreich versendet. Wir werden uns in Kürze mit Ihnen in
            Verbindung setzen.
          </p>
        </div>
      </section>
    );
  }

  // Otherwise, render the form
  return (
    <section className="request-form-section">
      <Seo
        title="Projektanfrage & Kontakt | Nexite IT Köln"
        description="Fordern Sie eine kostenlose Erstberatung an: Erzählen Sie uns von Ihrem Web-, App- oder Design-Projekt – wir melden uns innerhalb von 24 Stunden."
        path="/kontakt"
      />
      <div className="request-form-container">
        {/* Header */}
        <div className="request-form-header">
          <h1>Kostenlose Erstberatung anfordern</h1>
        </div>

        {/* Formular */}
        <form className="request-form" ref={formRef} onSubmit={handleSubmit}>
          {/* Name and Company */}
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="name">Ihr Name</label>
              <input
                type="text"
                id="name"
                name="name"
                placeholder="Max Mustermann"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="company">Ihr Firmenname</label>
              <input
                type="text"
                id="company"
                name="company"
                placeholder="Mustermann GmbH"
                required
              />
            </div>
          </div>

          {/* Email and Phone */}
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="email">E-Mail-Adresse</label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="max@mustermann.de"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="phone">Telefonnummer</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                placeholder="+49 170 1234567"
              />
            </div>
          </div>

          {/* Budget Input */}
          <div className="form-group budget-group">
            <label htmlFor="budget">Ihr Budget (in EUR)</label>
            <input
              type="number"
              id="budget"
              name="budget"
              placeholder="10.000"
              required
            />
          </div>

          {/* Message */}
          <div className="form-group">
            <label htmlFor="message">Wie können wir Ihnen helfen?</label>
            <textarea
              id="message"
              name="message"
              placeholder="Geben Sie hier Ihre Nachricht ein..."
              rows="4"
              ref={textareaRef}
              onInput={autoResizeTextarea}
              required
            ></textarea>
          </div>

          {/* Services */}
          <div className="form-group">
            <label>Dienstleistungen</label>
            <div className="services-checkbox-group">
              <label className="checkbox-label">
                <input type="checkbox" name="services" value="Web Entwicklung" /> Web
                Entwicklung
              </label>
              <label className="checkbox-label">
                <input type="checkbox" name="services" value="App Entwicklung" /> App
                Entwicklung
              </label>
              <label className="checkbox-label">
                <input type="checkbox" name="services" value="UI/UX Design" /> UI/UX
                Design
              </label>
            </div>
          </div>

          {/* Submit Button */}
          <button type="submit" className="submit-button" disabled={isSending}>
            {isSending ? "Wird gesendet…" : "Anfrage senden"}
          </button>

          {errorMessage && (
            <p className="form-error" role="alert">
              {errorMessage}
            </p>
          )}
        </form>
      </div>
    </section>
  );
};

export default RequestForm;
